import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Tabs, Tab, } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import PmorderPage from "components/pmorder/page/PmorderPage";
import { setTaskApiResponse, setTaskApiResponseError } from "store/slice/AppSlice";
import CommentMgmt from "./comment/CommentMgmt";

export default function TaskSpaceStore() {
  const dispatch = useDispatch();
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const {pmorderList } = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const { taskApiResponse, taskApiResponseError } = useSelector((state) => state.appslice.wkflow);
  const [tabIndex, setTabIndex] = useState(0);
  
  
  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(''));
  },[]);

useEffect(() => {
    if (
      pmorderList &&
      pmorderList.length > 0 &&
      pmorderList.every(item => item.pmstatus === "RECEIVED")
    ) {
      dispatch(setCompleteTaskButtonEnabled(true));
    } else {
      dispatch(setCompleteTaskButtonEnabled(false));
    }
  }, [pmorderList, dispatch]);

  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} >
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
                                <Tabs
                                  value={tabIndex}
                                  onChange={(_, v) => setTabIndex(v)}
                                  variant="fullWidth"
                                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                                >
                                  <Tab label="Product Info" />
                                  <Tab label="Comments" />
                                </Tabs>
                                <Box sx={{}}>
                                  {tabIndex === 0 && (
                                    <ProductInfo maxHeight="70vh" />
                                  )}
                                  {tabIndex === 1 && (
                                    <Box sx={{ p: 2, minHeight: '70vh' }}>
                                      <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                                        <CommentMgmt maxHeight="60vh" status={1} />
                                      </Box>
                                    </Box>
                                  )}
                                </Box>
                              </Box>
          </Grid>
          <Grid item lg={8} md={4} sm={4} xs={4} >
            {taskApiResponse?<></>:
            <PmorderPage />
            }
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}